<template>
  <nav class="mobile-footbar">
    <router-link 
      :to="{ path: '/dashboard' }" 
      class="mobile-footbar-item"
      :class="{ 'is-active': isActive('dashboard') }"
    >
      <i class="fas fa-chart-pie"></i>
      <span>Accueil</span>
    </router-link>
    
    <router-link 
      :to="{ name: 'account/infos' }" 
      class="mobile-footbar-item"
      :class="{ 'is-active': isActive('account') }"
    >
      <i class="fas fa-user-circle"></i>
      <span>Compte</span>
    </router-link>
    
    <router-link 
      :to="{ name: 'catalog/productlist' }" 
      class="mobile-footbar-item"
      :class="{ 'is-active': isActive('catalog') }"
    >
      <i class="fas fa-box"></i>
      <span>Catalogue</span>
    </router-link>
    
    <router-link 
      :to="{ name: 'myorders' }" 
      class="mobile-footbar-item"
      :class="{ 'is-active': isActive('orders') }"
    >
      <i class="fas fa-clipboard-list"></i>
      <span>Commandes</span>
    </router-link>
  </nav>
</template>

<script setup lang="ts">
/* eslint-disable vue/multi-word-component-names */
import { useRoute } from 'vue-router'

const route = useRoute()

const isActive = (section: string) => {
  const path = route.path
  
  switch (section) {
    case 'dashboard':
      return path === '/dashboard' || path === '/'
    case 'catalog':
      return path.startsWith('/catalog')
    case 'orders':
      return path.startsWith('/orders') || path.startsWith('/orderdetails') || route.name === 'myorders'
    case 'account':
      return path.startsWith('/account')
    default:
      return false
  }
}
</script>

<style lang="scss" scoped>
.mobile-footbar {
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #ffffff;
    border-top: 1px solid #e5e7eb;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    justify-content: space-around;
    align-items: center;
    padding: 0.5rem 0;
    height: 65px;
  }
  
  &-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    text-decoration: none;
    color: #000000;
    font-size: 0.75rem;
    padding: 0.5rem 1rem;
    transition: all 0.2s ease;
    flex: 1;
    max-width: 25%;
    
    i {
      font-size: 1.25rem;
      margin-bottom: 0.125rem;
    }
    
    span {
      font-size: 0.7rem;
      font-weight: 500;
      line-height: 1;
      white-space: nowrap;
      overflow: visible;
    }
    
    &:hover {
      color: #000000;
    }
    
    &.is-active {
      color: #3b82f6;
      
      i {
        color: #3b82f6;
      }
      
      span {
        color: #3b82f6;
        font-weight: 600;
      }
    }
    
    &.router-link-active {
      color: #3b82f6;
      
      i {
        color: #3b82f6;
      }
      
      span {
        color: #3b82f6;
        font-weight: 600;
      }
    }
  }
}

@media print {
  .mobile-footbar {
    display: none !important;
  }
}
</style>

